import { render, staticRenderFns } from "./StatisticsGrafana.vue?vue&type=template&id=606b6b3b"
import script from "./StatisticsGrafana.vue?vue&type=script&lang=js"
export * from "./StatisticsGrafana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports